import React, { memo, useState, useEffect } from "react";
import Link from "next/link";
import { client } from '@/lib/sanity';

interface Category {
  _id: string;
  title: string;
  slug: { current: string };
}

const query = `*[_type == 'category' && (
  title == "Yoga Flow" ||
  title == "Restorative" ||
  title == "Cardio" ||
  title == "Fusion" ||
  title == "Core"
)] | order(title asc) {
  _id,
  title,
  slug
}`;

const StyleCategoriesSection = memo(() => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const data = await client.fetch(query);
        setCategories(data);
        setLoading(false);
      } catch (error: any) {
        setError("Failed to load style categories.");
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  if (loading) return <div className="loading">Loading styles...</div>;
  if (error) return <div className="error text-center p-4">{error}</div>;
  if (categories.length === 0) return <div className="text-center p-4">No style categories found</div>;

  return (
    <div className="style-category-section section-padding">
      <h4 className="main-title mb-3">Movement Styles</h4>
      <div className="style-category-grid d-flex flex-wrap gap-3">
        {categories.map((cat) => (
          <Link
            key={cat._id}
            href={`/categories/${cat.slug.current}`}
            className="btn btn-outline-primary rounded-pill px-4 py-2 style-category-link"
          >
            {cat.title}
          </Link>
        ))}
      </div>
    </div>
  );
});

StyleCategoriesSection.displayName = "StyleCategoriesSection";
export default StyleCategoriesSection;
